var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("InvestmentReport.Menu.BasicInfo")) + "\n  "
      )
    ]),
    _vm._v(" "),
    _vm.basicInfo
      ? _c(
          "div",
          [
            _c("text-label-row", {
              attrs: { title: "AidTargetNumber", id: "aidtargetnumber" },
              model: {
                value: _vm.basicInfo.aidTarget,
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo, "aidTarget", $$v)
                },
                expression: "basicInfo.aidTarget"
              }
            }),
            _vm._v(" "),
            _c("text-label-row", {
              attrs: { title: "Purpose", id: "purpose" },
              model: {
                value: _vm.basicInfo.purpose,
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo, "purpose", $$v)
                },
                expression: "basicInfo.purpose"
              }
            }),
            _vm._v(" "),
            _vm.hasTerms
              ? _c("text-label-row", {
                  attrs: {
                    title: "InvestmentReport.BasicInfo.AidTargetDecisionTerms",
                    id: "aidtargetdecisionterms"
                  },
                  model: {
                    value: _vm.basicInfo.aidTargetDecisionTerms,
                    callback: function($$v) {
                      _vm.$set(_vm.basicInfo, "aidTargetDecisionTerms", $$v)
                    },
                    expression: "basicInfo.aidTargetDecisionTerms"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("granted-amounts-list", {
              attrs: {
                title: "InvestmentReport.BasicInfo.GrantedAmounts",
                aidYears: _vm.basicInfo.grantedYears
              }
            }),
            _vm._v(" "),
            _vm.basicInfo.aidPercent
              ? _c("text-label-row", {
                  attrs: {
                    title: "InvestmentReport.BasicInfo.AidPercent",
                    id: "aidpercent",
                    value: _vm.basicInfo.aidPercent.toString(),
                    sign: "%"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("date-input-row", {
              attrs: {
                title: _vm.startTimeTitle,
                name: _vm.startTimeTitle,
                placeholder: _vm.$t("DatePicker.FormatPlaceholder"),
                required: true,
                rules: _vm.startTimeRules
              },
              model: {
                value: _vm.basicInfo.startDate,
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo, "startDate", $$v)
                },
                expression: "basicInfo.startDate"
              }
            }),
            _vm._v(" "),
            _c("date-input-row", {
              attrs: {
                title: _vm.endTimeTitle,
                name: _vm.endTimeTitle,
                placeholder: _vm.$t("DatePicker.FormatPlaceholder"),
                required: true,
                rules: _vm.endTimeRules
              },
              model: {
                value: _vm.basicInfo.endDate,
                callback: function($$v) {
                  _vm.$set(_vm.basicInfo, "endDate", $$v)
                },
                expression: "basicInfo.endDate"
              }
            }),
            _vm._v(" "),
            _vm.isICT || _vm.isBudgetaryEstimate
              ? _c(
                  "div",
                  [
                    _c("radio-button-option-row", {
                      staticClass: "radio-button-lengthy-labels",
                      attrs: {
                        title: "InvestmentReport.BasicInfo.TenderStatus",
                        required: true,
                        options: _vm.optionsArray(
                          "InvestmentTenderStatus",
                          true
                        )
                      },
                      model: {
                        value: _vm.basicInfo.tenderStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.basicInfo, "tenderStatus", $$v)
                        },
                        expression: "basicInfo.tenderStatus"
                      }
                    }),
                    _vm._v(" "),
                    _vm.showNoTenderExplanation
                      ? _c("text-area-row", {
                          attrs: {
                            title:
                              "InvestmentReport.BasicInfo.NoTenderExplanation",
                            id: "notenderexplanation",
                            required: true,
                            maxLength: 500,
                            rows: 7
                          },
                          model: {
                            value: _vm.basicInfo.noTenderExplanation,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.basicInfo,
                                "noTenderExplanation",
                                $$v
                              )
                            },
                            expression: "basicInfo.noTenderExplanation"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isPremises
              ? _c(
                  "div",
                  [
                    !_vm.isBudgetaryEstimate
                      ? _c(
                          "div",
                          [
                            _c("radio-button-option-row", {
                              staticClass: "radio-button-lengthy-labels",
                              attrs: {
                                title:
                                  "InvestmentReport.BasicInfo.InvestmentTarget",
                                required: true,
                                options: _vm.optionsArray(
                                  "PremisesInvestmentType",
                                  true
                                )
                              },
                              model: {
                                value: _vm.basicInfo.investmentTarget,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.basicInfo,
                                    "investmentTarget",
                                    $$v
                                  )
                                },
                                expression: "basicInfo.investmentTarget"
                              }
                            }),
                            _vm._v(" "),
                            _vm.showOtherTargetDescription
                              ? _c("text-area-row", {
                                  attrs: {
                                    title:
                                      "InvestmentReport.BasicInfo.OtherTargetDescription",
                                    id: "othertargetdescription",
                                    required: true,
                                    maxLength: 100,
                                    rows: 2
                                  },
                                  model: {
                                    value: _vm.basicInfo.otherTargetDescription,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.basicInfo,
                                        "otherTargetDescription",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "basicInfo.otherTargetDescription"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("target-info-control", {
                      attrs: {
                        item: _vm.basicInfo.targetInfo,
                        isInvestmentReport: true,
                        isBudgetaryEstimate: _vm.isBudgetaryEstimate
                      }
                    }),
                    _vm._v(" "),
                    _c("address-control", {
                      attrs: {
                        item: _vm.basicInfo.address,
                        isInvestmentReport: true,
                        isBudgetaryEstimate: _vm.isBudgetaryEstimate
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }